<template>
  <VLayout :title="$t('home_user.my_account')" :subtitle="$t('home_user.welcome')">
    <div>
      <VListCardHomeLinks />
    </div>
    <VButtonGroup
      :hide_primary="true"
    />
  </VLayout>
</template>

<script>
import { mapGetters } from "vuex";
import VLayout from "@/layouts/Default";
import VListCardHomeLinks from "@/components/VListCardHomeLinks";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    VListCardHomeLinks,
    VButtonGroup,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
  },
  mounted() {
    if (!this.$route.params.pt_uuid && this.getUuidPatientSelected) {
      this.$router.push({
        name: "userhome",
        params: { pt_uuid: this.getUuidPatientSelected },
      });
    }
  },
  fallbackI18n: {
    messages: {
      und: {
        home_user: {
          my_account: "My Account",
          welcome: "WELCOME TO YOUR ACCOUNT CONFIGURATION PANEL.",
        },
      },
    },
  },
};
</script>

<style>
</style>
